import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'login',

  data() {
    return {
      userId: '',
      password: '',
      imageSrc: require('../../../img/md_logo.png'),
      loading: true
    }
  },

  computed: {
    ...mapGetters('auth', ['errMsg'])
  },

  methods: {
    ...mapActions('category', ['resetCategory']),
    ...mapActions('store', ['resetStore']),
    ...mapActions('summary', ['resetSummary']),
    ...mapActions('itemlist', ['resetItemlist']),

    ...mapActions('auth', [
      'login',
      'logout'
    ]),

    async onLogin() {
      this.loading = false

      await this.login({
        userId: this.userId,
        password: this.password
      })

      // ログインエラー時
      if (this.errMsg) {
        this.password = ''
        // フォーカスする
        if (!this.userId) {
          document.login.user.focus()
        } else {
          document.login.pass.focus()
        }
      } else {
        this.$router.push('dashboard')
      }
      this.loading = true
    }
  },

  created() {
    // ログイン画面からブラウザフォワードでログインできないようにする
    this.logout()

    // 初期化
    this.resetCategory()
    this.resetStore()
    this.resetSummary()
    this.resetItemlist()
  }
}



// WEBPACK FOOTER //
// ./src/components/login/login.js